import axios from "axios";

export default class mediaLibrary {
  constructor() {}

  getAccounts = () => axios.get("/accounts");
}

const locationsCache = {};
export async function searchLocation({ query }) {
  if (!locationsCache[query]) {
    const request = axios
      .get("/location/query", {
        params: { query },
      })
      .catch((error) => {
        if (locationsCache[query] === request) delete locationsCache[query];
        throw error;
      });
    locationsCache[query] = request;
  }
  const {
    data: { data },
  } = await locationsCache[query];
  return data;
}
